<template>
	<!-- 初始老版本，没用可删除 -->
	<div id="usercenter-gover" v-title data-title="用户中心-用户画像" class="usercenter">
 <headerbar :curindex="false"></headerbar>
	<div class="userpage centerpage">
		<usermenu :indexnum="5"></usermenu>
		<div class="user_left usercenter-gover"> 
		<div class="goverC_top">
			<dl class="fl oh">
				<dt class="fl"><img src="../../assets/images/gadvtar.png" alt=""></dt>
				<dd class="fl"><h5>{{userdata.cityText}}政府</h5><p>{{userdata.username}}</p></dd>
			</dl>
			<!-- <span class="fr">上次登录时间：2021-11-29 16:10:08</span> -->
		</div>
			<h2 class="usertitle">宏观数据</h2>
			<div class="whitebox">
				<div class="userr_w_title">
					<h3 class="fl">{{userdata.cityText}}GDP</h3>
					<a class="fr" :href="resdata.analyseUrl" target="_blank">{{userdata.cityText}}投资环境报告</a>
				</div>
				<div class="echartbox" id="cityinvestenvir"></div>
			</div>
			<div class="oh twoblock userc_block1 whitebox">
				<div class="fl"> 
					<h3 class="userr_w_title">所辖县数据</h3>
					<div class="reportlist">
						<a class="report_a" v-for="item in resdata.countyList" target="_blank" :href="item.url" >{{item.cityName}}投资环境评估分析报告</a>
					</div>
				</div>
				<div class="fr">
						<h3 class="userr_w_title">所辖乡镇数据</h3> 
						<div class="reportlist">
							<a class="report_a" v-for="item in resdata.townList" target="_blank" :href="item.url" >{{item.cityName}}宏观经济与社会发展基础数据</a>
						</div>
				</div>
			</div>
			<h2 class="usertitle">产业发展</h2> 
			<div class="whitebox userc_block2">
				<h3 class="userr_w_title">产业链</h3>  
				<div class="reportlist">
					<span class="report_a" v-for="item in resdata.chainList" @click="chainrouter1(item.chainId)">{{item.chainName}}</span> 
				</div>
			</div>
			<div class="oh twoblock chanyefazhan">
				<div class="whitebox fl"> 
					<h3 class="userr_w_title">上市公司投资趋势</h3>  
					<div id="userc_invest_trend" class="echartbox" ></div>
				</div>
				<div class="whitebox fr ">
					<h3 class="userr_w_title">投资指南</h3>  
					<div class="reportlist" >
						<a class="report_a" v-for="item in resdata.guideList" :href="item.url" target="_blank">{{item.title}}</a>
					</div> 
				</div>
			</div>
			<div class="whitebox">
				<h3 class="userr_w_title">上市公司投资项目</h3>
				<div class="oh" style="padding-bottom: 40px;">
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="userc_table userc_table1 tac">
						<tr><th class="xuhaotd">序号</th><th>公司名称</th><th>项目名称</th> <th>投资金额</th><th>投资时间</th></tr>
						<tr v-for="(item,index) in resdata.investProject">
							<td>{{index+1}}</td>
							<td><span :class="item.stockCode!=0 ?'curp' : ''" @click="companyrouter('/enterprises',item.stockCode,2)">{{item.title}}</span></td>
							<td>{{item.projectName}}</td> 
							<td>{{item.money}}</td> 
							<td>{{item.date}}</td> 
						</tr> 
					</table>
				</div> 
			</div> 
			<h2 class="usertitle">产业用地</h2>
			<div class="whitebox">
				<div class="userr_w_title">
					<h3 class="fl">成交趋势</h3>
					<a class="fr" :href="resdata.landUrl" target="_blank">{{userdata.cityText}}产业用地市场交易深度分析报告</a> 
				</div> 
				<div class="echartbox" id="landtrend1"></div>
			</div>  
			<div class="whitebox"> 
				<h3 class="userr_w_title">拿地项目</h3>  
				<table border="0" cellspacing="0" cellpadding="0" width="90%" class="userc_table userc_table2 tac reportlist mga"> 
					<tr><th>行政区域</th><th>项目名称</th><th>总面积(亩)</th><th>总金额(万元)</th><th>土地用途</th><th>土地使用权人</th></tr> 
					<tr v-for="list in resdata.landList"> 
					<td>{{list.area}}</td>
					<td>{{list.projectName}}</td> 
					<td>{{list.size}}{{list.sizeUnit}}</td>
					<td>{{list.amount}}{{list.amountUnit}}</td>
					<td>{{list.purpose}}</td> 
					<td><span v-if="list.owner != ''">{{list.owner}}</span><span v-if="list.owner == ''">-</span></td>
					</tr> 
				</table>
			</div> 
			<h2 class="usertitle">企业数据</h2>
			<div class="oh twoblock userc_block1 whitebox">
				<div class="fl"> 
					<h3 class="userr_w_title">大企业</h3>
					<div class="reportlist">
						<span class="report_a" v-for="item in resdata.bigEnt" @click="companyrouter('/enterprises',item.stockCode,2)">{{item.title}}</span> 
					</div>
				</div>
				<div class="fr">
						<h3 class="userr_w_title">创新企业</h3> 
						<div class="reportlist">
							<span class="report_a" v-for="item in resdata.smallEnt" @click="companyrouter('/enterprises',item.stockCode,3)">{{item.title}}</span> 
						</div>
				</div>
			</div>
			<div class="oh twoblock userc_block1 whitebox">
				<div class="fl"> 
					<h3 class="userr_w_title">研发机构</h3>
					<div class="reportlist">
						<span class="report_a" v-for="item in resdata.academy" @click="companyrouter('/resources-enterprises',item.id)">{{item.title}}</span>  
					</div>
				</div>
				<div class="fr">
						<h3 class="userr_w_title">投资机构</h3> 
						<div class="reportlist"> 
							<span class="report_a" v-for="item in resdata.investOrg" @click="companyrouter('/investement-enterprises',item.id)">{{item.name}}</span> 
						</div>
				</div>
			</div> 
		</div> 
	</div> 
	<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'govermentcenter',
			data(){
				return{ 
					userdata:{}, 
					resdata:{},
					public_tooltip: { trigger: 'axis', 	backgroundColor: 'rgba(255,255,255,0.9)', borderColor: '#ddd', borderWidth: '1', textStyle: { color: '#000', fontSize: 14, } },
					colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
			}},  
			beforeCreate() {
				
			},
			created() {
			this.userdata=this.common.userdata.length>0?this.common.userdata:this.getuseriformation();
			this.bus.$emit('loading', true);
		
			},
			mounted() {
			 let _this=this;
			 this.$axios.get(this.$api.cyl.usercenter.index(),{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
			 	if(res.data.success){  
			 		_this.resdata=res.data.data;
			 		console.log(_this.resdata); 
			 		_this.gdplistvaluefun(res.data.data.gdpList); 
			 		_this.companyinvesttrenddata('userc_invest_trend',res.data.data.investTrend);
			 		_this.companyinvesttrenddata('landtrend1',res.data.data.landTrend);
			 		setTimeout(function(){_this.bus.$emit('loading',false);},1200);
			 	}else{ 
			 			
			 	} 
			 }).catch(function (error) { 
			 	// 请求失败处理 console.log(error);
			 });
				
			},
			methods:{
				otherlink(urls){
					console.log(urls);
					window.open(urls, '_blank');  
				},
				chainrouter1(chainid){
					let routeUrl = this.$router.resolve({
							path: '/chain',query:{id:chainid}
					});
					window.open(routeUrl.href, '_blank');  
				},
				companyrouter(path,id,type){
					if(id == 0 || id == ""){
						return;
					};
					var querys={id:id};
					if(type){
						querys.type=type;
					}
					let routeUrl = this.$router.resolve({
							path: path,query: querys
					});
					window.open(routeUrl.href, '_blank');  
				}, 
				gdplistvaluefun(gdplistd){
					var gdplistvalue={};
					var xline=[],yline=[],yline1=[];
					for(var i=0;i<gdplistd.length;i++){
						xline.push(gdplistd[i].year);
						yline.push(gdplistd[i].gdp);
						yline1.push(gdplistd[i].speedUp);
					} 
					gdplistvalue.unit=[gdplistd[0].gdpUnit,gdplistd[0].speedUPUnit]; 
					gdplistvalue.xline=xline;
					gdplistvalue.yline=yline;
					gdplistvalue.yline1=yline1; 
					gdplistvalue.name=['gdp','gdp增速'];
					this.twoDataEchart('cityinvestenvir',gdplistvalue);
				},
				companyinvesttrenddata(idname,datas){ 
					var gdplistvalue={}; 
					var xline=[],yline=[],yline1=[],yline2=[]; 
					for(var i=0;i<datas.length;i++){
						xline.push(datas[i].date);
						yline.push(datas[i].value);
						yline1.push(datas[i].hb);
						yline2.push(datas[i].tb); 
					};  
					gdplistvalue.unit=["项","%","%",]; 
					gdplistvalue.xline=xline;
					gdplistvalue.yline=yline;
					gdplistvalue.yline1=yline1; 
					gdplistvalue.yline2=yline2; 
					gdplistvalue.name=['项目数量','环比','其它同比']; 
					this.companyinvesttrend(idname,gdplistvalue);
				},
				twoDataEchart($el, datas) {
					//	initCalendar(); 
					//if($el.length<0)return;
					let chart = echarts.init(document.getElementById($el));
					var _this = this;
					let options3 = {
						tooltip: _this.public_tooltip,
						color: _this.colors,
						// legend: { 	data: datas.name, top: 20, left: "center", },
						grid: { x: 80, y: 50, x2: 80, 	y2: 30, show: true, backgroundColor: "#f8fbfe", borderWidth: 0,},
						xAxis: { type: 'category', 	data: datas.xline, axisLine: { lineStyle: { color: "#aaa", 	width: 1 } }, 	nameTextStyle: { fontSize: 12 },},
						yAxis: [
							{type: 'value',splitLine: {show: false},axisLine: {lineStyle: {color: "#aaa",width: 1}},splitLine: {lineStyle: { color: ["#eee"], width: 1}},fontsize: 12,name: datas.unit[0],axisLabel: {formatter: '{value}',}},
							{type: 'value',axisLine: {lineStyle: {color: "#aaa",width: 1}},splitLine: {lineStyle: {color: ["#eee"],width: 1}},name: datas.unit[1],	axisLabel: {formatter: '{value}',}}
						],
						series: [
							{ name: datas.name[0],type: 'bar',barWidth: 40, data: datas.yline},
							{name: datas.name[1],type: 'line', symbol: 'circle',symbolSize: 10,yAxisIndex: 1,data: datas.yline1,},
						]
					};  
					options3.tooltip.formatter=function(params){ 
						let retuhtml="<h5 class='tootititle'>"+params[0].name+"年</h5>";
						for(var i=0;i<params.length;i++){ 
							retuhtml+="<p>"+params[i].marker + params[i].seriesName+"：" + params[i].value + datas.unit[i]+"</p>"  ; 
						}   
						return retuhtml;  
					} 
				chart.setOption(options3);
				},
				companyinvesttrend($el, datas) { 
					var chart = echarts.init(document.getElementById($el));
					var _this = this; 
					let yxids=[];
					for(var i=0;i<datas.name.length;i++){
						yxids.push( { 	type: 'value', name: datas.unit[i],   axisLabel: { formatter: '{value} '}},); 
					} 
					var option = {
					tooltip: this.public_tooltip, 
					color:this.colors,
					grid: { x: 80, y: 50, x2: 80, 	y2: 30, show: true, backgroundColor: "#f8fbfe", borderWidth: 0,},
					xAxis: { type: 'category', data: datas.xline,axisLine: { lineStyle: { color: "#aaa", 	width: 1 } }, 	nameTextStyle: { fontSize: 12 },} ,
					yAxis: yxids,
					series: [  
						{name: datas.name[0], type: 'bar', barWidth:30, data: datas.yline },
						{name: datas.name[1], type: 'line', yAxisIndex: 1, data: datas.yline1 },
						{name: datas.name[2],type: 'line', yAxisIndex: 1, data:  datas.yline2}
					]
				};  
				option.tooltip.formatter=function(params){
					let retuhtml="<h5 class='tootititle'>"+params[0].name+"</h5>";
					for(var i=0;i<params.length;i++){ 
						retuhtml+="<p>"+params[i].marker + params[i].seriesName+"：" + params[i].value + datas.unit[i]+"</p>"  ; 
					}   
					return retuhtml;  
				} 
					chart.setOption(option);
				},
			
			}
	}
	
	
	
</script>

<style> 
	
	
</style>
